export default __webpack_public_path__ + "static/loading-indicator-a6b7f4008c297a6a0c64197a0e06e0ef.gif";